import React from 'react'
import { VirtualCard } from '../../types'
import { SubGroupLabel, TableHeader } from '../components'
import { VirtualCardsListItem } from './VirtualCardsListItem'

interface Props {
  virtualCards: VirtualCard[]
  username: string
}

export const VirtualCardsList: React.FC<Props> = ({
  virtualCards,
  username,
}) => (
  <>
    <SubGroupLabel>Card Details</SubGroupLabel>
    <table>
      <tbody>
        <tr>
          <TableHeader>Card</TableHeader>
          <TableHeader>Status</TableHeader>
          <TableHeader>Last 4</TableHeader>
          <TableHeader>Canceled</TableHeader>
        </tr>
        {virtualCards.map((card: VirtualCard, i) => {
          const cardDisplayName = `Card ${i + 1}`

          return (
            <VirtualCardsListItem
              card={card}
              cardDisplayName={cardDisplayName}
              username={username}
              key={cardDisplayName}
            />
          )
        })}
      </tbody>
    </table>
  </>
)
